export default __webpack_public_path__ + "static/testimonial-d8c0292724665ae9b8760b64f8451640.png";